import { ArrowUpRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOKING_URL, BUSINESS } from "@/lib/site";
import { trackEvent } from "@/lib/analytics";
import { Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

export function ContactCTA() {
  const photo = PHOTOS.parkModelPatio;

  return (
    <section
      className="relative isolate overflow-hidden bg-forest-deep py-28 sm:py-32 lg:py-40"
      aria-labelledby="contact-cta-title"
    >
      <img
        src={photo.src}
        srcSet={photo.srcSet}
        sizes={PHOTO_SIZES.fullBleed}
        alt=""
        width={photo.width}
        height={photo.height}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 -z-10 size-full object-cover"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 -z-10 bg-[linear-gradient(180deg,oklch(0.259_0.042_163.6/0.84)_0%,oklch(0.259_0.042_163.6/0.93)_100%)]"
        aria-hidden="true"
      />

      <Reveal className="mx-auto max-w-3xl px-4 text-center text-cream sm:px-6">
        <p className="eyebrow text-sand">Ready to Visit Zapata?</p>
        <h2
          id="contact-cta-title"
          className="mt-4 text-balance font-display text-3xl leading-tight sm:text-4xl lg:text-[3rem]"
        >
          Start Planning Your Amigo Inn Stay
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-cream/85 sm:text-lg">
          Check current availability for RV sites, cabins, rooms, and tent camping, or contact our
          team if you need help selecting the right option.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Button asChild variant="book" size="ctaLg">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("booking_link_clicked", { location: "contact_cta" })}
            >
              Check Availability <ArrowUpRight aria-hidden="true" />
            </a>
          </Button>
          <Button asChild variant="outlineLight" size="ctaLg">
            <a
              href={BUSINESS.phoneHref}
              onClick={() => trackEvent("phone_link_clicked", { location: "contact_cta" })}
            >
              <Phone aria-hidden="true" /> Call the Park
            </a>
          </Button>
        </div>
      </Reveal>
    </section>
  );
}
